export default {
	annotation: {
		backToList: 'Return to List',
		edit: 'Edit Annotation',
		save: 'Save Annotation',
		dragTip: 'Click canvas to add annotation point, drag to adjust position',
		noDeviceId: 'Device ID not found',
		defaultDeviceName: 'Unknown Device',
		loadFailed: 'Load Failed',
		atLeastOnePoint: 'Please add at least one annotation point',
		pointAdded: 'Annotation point added',
		pointDeleted: 'Annotation point deleted',
		saveSuccess: 'Saved successfully',
		saveFallback: 'Save failed, saved to local cache',
		annotationPoint: 'Annotation Point',
		imageLoadFailed: 'Image load failed',
		editModeStarted: 'Edit mode started',
		bindDevice: 'Bind Device',
		noDeviceAvailable: 'No devices available',
		fetchDeviceListFailed: 'Failed to fetch device list',
		noDeviceAvailableForBind: 'No devices available for binding',
		deviceBound: 'Device bound successfully',
		close: 'Close',
		device: 'Device{deviceId}'
	}
}
